import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useEffectiveDojo } from './useEffectiveDojo';

export const useStudentsData = (isOpen: boolean) => {
  const { effectiveDojoId, shouldFilterByDojo } = useEffectiveDojo();
  const client = useQueryClient();
  const queryKey = ['students', effectiveDojoId, shouldFilterByDojo];
  const enabled = isOpen && (!!effectiveDojoId || !shouldFilterByDojo);
  const query = useQuery({ queryKey, enabled, refetchOnMount: 'always', queryFn: async () => {
    if (shouldFilterByDojo && !effectiveDojoId) return [];
    // SELECT * tolerates databases where the optional status migration has not run yet.
    let request = supabase.from('profiles').select('*').eq('role', 'student').order('first_name');
    if (effectiveDojoId) request = request.eq('dojo_id', effectiveDojoId);
    const { data, error } = await request;
    if (error) throw error;
    return data || [];
  }});
  useEffect(() => {
    if (!enabled) return;
    const channel = supabase.channel(`students-${effectiveDojoId || 'all'}`)
      .on('postgres_changes', { event: '*', schema: 'public', table: 'profiles', ...(effectiveDojoId ? { filter: `dojo_id=eq.${effectiveDojoId}` } : {}) }, () => {
        client.invalidateQueries({ queryKey: ['students'] });
        client.invalidateQueries({ queryKey: ['dashboard-overview'] });
      }).subscribe();
    return () => { supabase.removeChannel(channel); };
  }, [enabled, effectiveDojoId, client]);
  return { students: query.data || [], isLoading: query.isLoading, error: query.error, refetch: query.refetch };
};
